import React from 'react'
import PortfolioListContainer from './PortfolioListContainer'

export default function PortfolioListScreen() {
    return <PortfolioListContainer />
}
